<div class="row text-left justify-content-md-center mt-5">
  <div class="col-md-6">
    <div class="card">
      <div class="card-header">
        <h4 class="card-title" id="basic-layout-form">{{ 'account.twoFactorSetup.title' | translate }}</h4>
        <p class="mb-0">{{ 'account.twoFactorSetup.text' | translate }}</p>
      </div>
      <div class="card-body">
        <div class="px-3">
          <form class="form" #twoFactorSetupForm="ngForm" (ngSubmit)="onSubmit(twoFactorSetupForm)">
            <div class="form-body">
              <h4 class="form-section">
                <i class="ft-cpu"></i> {{ 'account.twoFactorSetup.detailsHeader' | translate }}
              </h4>

              <!-- QR Code -->
              <div class="form-group">
                <label>{{ 'account.twoFactorSetup.qrCodeFieldLabel' | translate }}</label>
                <qrcode class="qrcode" [qrdata]="qrcodeDataUrl" [width]="256" [errorCorrectionLevel]="'H'"></qrcode>
              </div>

              <!-- PreSharedKey -->
              <div class="form-group">
                <label for="PreSharedKey">{{ 'account.twoFactorSetup.preSharedKeyFieldLabel' | translate }}</label>
                <input id="PreSharedKey" class="form-control" required name="PreSharedKey" #PreSharedKey="ngModel"
                       [(ngModel)]="currentObject.PreSharedKey"
                       placeholder="{{'account.twoFactorSetup.preSharedKeyFieldPlaceHolder' | translate}}"
                       autocomplete="off"
                       readonly="readonly">
              </div>

              <!-- Two Factor Authentication Code -->
              <div class="form-group">
                <label
                  for="AuthenticationCode">{{ 'account.twoFactorSetup.authenticationCodeFieldLabel' | translate }}</label>
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">
                      <i class="icon-key"></i>
                    </span>
                  </div>
                  <input type="text" id="AuthenticationCode" class="form-control" name="AuthenticationCode" #AuthenticationCode="ngModel"
                         placeholder="{{'account.twoFactorSetup.authenticationCodeFieldPlaceHolder' | translate}}"
                         autocomplete="one-time-code"
                         [(ngModel)]="authenticationCode" required>
                </div>
              </div>
            </div>
            <div class="form-group text-center">
              <button class="btn btn-raised btn-raised btn-warning mr-1" type="button"
                      (click)="generateNewPreSharedKey()">
                <i class="icon-key"></i> {{ 'buttons.generateNewText' | translate }}
              </button>
              <button [disabled]="!twoFactorSetupForm.valid" class="btn btn-raised btn-raised btn-primary mr-1"
                      type="submit">
                <i class="ft-check-square"></i> {{ 'buttons.saveText' | translate }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
